<!--
 * @Description: 标签组件
 * @Date: 2019-09-24 10:33:04
 * @LastEditTime: 2019-10-12 17:02:40
 -->
<template>
    <div
        class="i-tag"
        :class="{
        'i-tag-o': type === 1,
        'i-tag-warning': type === 2,
        'i-tag-danger': type === 3
        }"
    >
        <span class="i-tag-text" v-if="text">{{text}}</span>
        <slot class="i-tag-text" v-else></slot>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: Number,
            default: 0
        },
        text: {
            type: String,
            default: ""
        }
    }
};
</script>

<style lang="scss" scoped>
.i-tag {
    display: inline-block;
    padding: 0 8px;
    box-sizing: border-box;
    background-color: rgba(239, 78, 43, 0.1);
    border-radius: 0 6px;
    margin-right: 10px;
    &:last-child {
        margin-right: 0;
    }

    .i-tag-text {
        font-size: 12px;
        color: #e8665e;
        line-height: 20px;
    }
}
.i-tag-o {
    background-color: rgba(239, 161, 43, 0.1);
    .i-tag-text {
        color: #ef9e54;
    }
}
.i-tag-warning {
    background-color: rgba(73, 190, 183, 0.2);
    .i-tag-text {
        color: #00a9ba;
    }
}
.i-tag-danger {
    background-color: rgba(57, 159, 255, 0.1);
    .i-tag-text {
        color: #359eff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Tag.vue